import axios from '../../../core/services/axios';

/* eslint-disable import/prefer-default-export */

export const getPetitions = (params) => axios.get('/api/petitions', { params });
